/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import InfoTooltip from '../InfoTooltip';

const DropdownItem = ({
  children, className, disabled, divider, onClick, showInfo, infoContent, infoPosition, ...others
}) => {
  const classes = cns(
    'dropdown__listItem',
    {
      'dropdown__listItem--disabled': disabled,
    },
    className,
  );

  return (
    divider
      ? <li className="divider" role="separator" />
      : (
        <li
          className={classes}
          {...others}
          role="menuitem"
          onClick={(event) => !disabled && onClick && onClick(event)}
        >
          {children}
          {showInfo && (
            <span
              data-clickable="false"
              style={{ cssFloat: 'right' }}
            >
              <InfoTooltip
                left={infoPosition === 'left'}
                right={infoPosition === 'right'}
              >
                {infoContent}
              </InfoTooltip>
            </span>
          )}
        </li>
      )
  );
};

DropdownItem.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se il componente è disabilitato */
  disabled: PropTypes.bool,
  /** Indica se il componente ha la funzione di separatore */
  divider: PropTypes.bool,
  /** Specifica il contenuto del componente InfoTooltip */
  infoContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Specifica se aprire il contenuto del componente spostato verso sinistra o destra */
  infoPosition: PropTypes.oneOf(['left', 'right']),
  /**
   * Callback invocata al click sul componente:
   * ```
   *  onClick(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onClick: PropTypes.func,
  /** Indica se mostrare o meno il componente InfoTooltip */
  showInfo: PropTypes.bool,
};

DropdownItem.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  divider: false,
  infoContent: '',
  infoPosition: 'left',
  onClick: null,
  showInfo: false,
};

export default DropdownItem;
